export class VendorPerformanceCpn {
  id: number;
  companyPartNumber: string;
  previousRemovalFsc: string;
  previousFscCompanyName: string;
  installCount: number;
  badFromStockCount: number;
  badFromStockRate: number;
  unscheduledCount: number;
  unscheduledRate: number;
  unscheduledOrBfsCount: number;
  unscheduledOrBfsRate: number;
  extremeInfantMortalityCount: number;
  extremeInfantMortalityRate: number;
  lowTsiUnder1000Count: number;
  lowTsiUnder1000Rate: number;
  lowTsiUnder20PercentCount: number;
  lowTsiUnder20PercentRate: number;
  m2Count: number;
  significantEventSum: number;
  significantEventCount: number;
  noFaultFoundRate: number;
}
